export default (values) => {
  const errors = {};

  if (!values?.text || values.text.length < 10) errors.text = true;

  return errors;
};
